// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-editor .nkl-select {
  width: 100%;
}
.color-editor .color-option-container {
  display: flex;
  align-items: center;
  height: 30px;
}
.color-editor .color-option-container .tint-shade-container {
  display: none;
}
.nkl-select-item-option-content .color-option-container {
  display: flex;
  align-items: center;
  height: 30px;
}
.nkl-select-item-option-content .tint-shade-container {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: auto;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper {
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0;
  height: 30px;
  width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper:hover {
  background-color: #0000001a;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper > span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper:not(:first-child)::before {
  background-color: transparent;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
